/**
 * 廣東話（繁體）dictionary — keys are the English source strings.
 * Colloquial Cantonese; station/stop names come from the data layer
 * (name_zh / name_tc), not from this file.
 */
export const zhHk = {
  "(Hong Kong time, UTC+8). Live clock.": "（香港時間，UTC+8）。實時時鐘。",
  "(Hong Kong time, UTC+8). Reset returns to live clock.": "（香港時間，UTC+8）。重設會返回即時時鐘。",
  "(UTC+8). Reset returns to Now.": "（UTC+8）。重設即返回「現在」。",
  "(merged official stops + OSRM densify).": "（已合併官方站點 + OSRM 加密點）。",
  "(orange). Official stop coords stay fixed (grey ghosts) for identity / merge.": "（橙色）。官方站點座標保持固定（灰色殘影）以維持身份／合併。",
  "*You might still need short station access if you disabled Walk. Plans to a stop/station itself stay listed.": "*如果你關咗步行，仍然可能需要短程車站接駁。計劃到站／車站本身仍會列出。",
  ", and": "，同",
  ", you can load a calculated path and edit turning points for moderators to review.": "，你可以載入計算路徑並編輯轉彎點，供版主審查。",
  "0 path pts": "0 個路徑點",
  "@Bus": "@巴士",
  "@LRT": "@輕鐵",
  "@MTR": "@港鐵",
  "AEL": "機場快綫",
  "bus": "巴士",
  "About": "關於",
  "About Travelers": "關於 Travelers",
  "Add via": "加入途經",
  "Airport Express (AEL)": "機場快綫（AEL）",
  "Alight": "落車",
  "Alight match": "落車匹配",
  "All done!": "全部完成！",
  "All done! Let's start enjoying your trip with Travelers!": "全部完成！讓我們一起享受你的 Travelers 旅程吧！",
  "All modes": "所有模式",
  "All operators": "所有營運商",
  "Allow location for origin, or set From manually": "允許位置作為出發地，或手動設定出發地",
  "Also fetches ETAs at the nearest stops and every 5th stop ahead and behind the selected stop, so positions are stitched from more anchors (extra requests per route view).": "亦會喺最近嘅站點，以及所選站點前後每第 5 個站點攞 ETA，令位置可以從更多錨點拼合（每個路線檢視會多啲請求）。",
  "App opens the PR with the site bot token (no GitHub login).": "應用程式會用網站 bot token 開 PR（無需 GitHub 登入）。",
  "App sections": "應用程式章節",
  "Application code © UNLOOP MORGAN 2026. Apache 2.0 does not grant trademark rights. “MORGAN”, “Travelers”, logos, and product naming may not be reused without permission.": "應用程式代碼 © UNLOOP MORGAN 2026。Apache 2.0 唔包括商標權。「MORGAN」、「Travelers」、標誌同產品名稱未經許可唔可以再用。",
  "Auto-caches only the app shell (UI, fonts, icons) so ordinary use never burns mobile data. Fares, route/stop data and the basemap are downloaded only when you press “Download offline data” below (≈ 55 MB) — press the button again after updates to refresh it.": "只會自動快取應用程式外殼（介面、字體、圖示），日常使用唔會燒流動數據。車費、路線／站點資料同底圖只會喺你撳下面「下載離線資料」先會下載（約 55 MB）——更新後再撳一次按鈕以重新整理。",
  "Back": "返回",
  "Back online": "恢復連線",
  "Back to search": "返回搜尋",
  "Back to trip": "返回行程",
  "Balanced": "平衡",
  "Basemap style and layer definitions (Protomaps).": "底圖樣式同圖層定義（Protomaps）。",
  "Basemap tiles generated from OpenStreetMap (via hk-pmtiles-generation) and served from the Travelers data edge.": "底圖瓦片由 OpenStreetMap 生成（經 hk-pmtiles-generation），由 Travelers 數據邊緣提供。",
  "Beta": "測試版",
  "Beta Feature": "測試版功能",
  "Beta Features": "測試版功能",
  "Beta banner enabled": "測試版橫額已啟用",
  "Beta banner hidden": "測試版橫額已隱藏",
  "Beta features": "測試版功能",
  "Beta warning banner": "測試版提示橫額",
  "Board": "上車",
  "Board match": "上車匹配",
  "Board/alight name fragments required (auto-filled after Load path).": "需要上車／落車名稱片段（載入路徑後會自動填入）。",
  "Bot account": "Bot 帳戶",
  "Box-select path points / offsets (B)": "框選路徑點／偏移（B）",
  "Branch": "分支",
  "Build and toolchain": "建置與工具鏈",
  "Build tool (VoidZero Inc. and Vite contributors).": "建置工具（VoidZero Inc. 同 Vite 貢獻者）。",
  "Bus": "巴士",
  "Bus · {cos}": "巴士 · {cos}",
  "Bus / GMB routes, stops and fares (FARE, ROUTE, RSTOP, STOP tables) plus realtime ETAs (rt.data.gov.hk, data.etabus.gov.hk).": "巴士／小巴路線、站點同車費（FARE、ROUTE、RSTOP、STOP 表），以及即時 ETA（rt.data.gov.hk、data.etabus.gov.hk）。",
  "Bus companies": "巴士公司",
  "Bus company": "巴士公司",
  "Bus paths are drawn live from the road network and can miss real alignments (e.g. Mei Tung Street vs the bus terminus). On": "巴士路線係即時沿道路網絡繪製，可能同真實走線有出入（例如美東街對比巴士總站）。開",
  "Bus: route no. · MTR: line code (TWL, ISL, TCL…) · AEL · LRT: route no. (505) · GMB: route code (auto region search)": "巴士：路線編號 · 港鐵：路綫代碼（TWL、ISL、TCL…）· AEL · 輕鐵：路線編號（505）· 小巴：路線代碼（自動地區搜尋）",
  "CTB": "城巴",
  "Cache": "快取",
  "Cache all data": "暫存所有資料",
  "Cache data on device": "喺裝置快取資料",
  "Cache transit data on this device for offline use and mobile data savings.": "在本機暫存交通資料，以備離線使用及節省流動數據。",
  "Cache: checking…": "快取：檢查中…",
  "Cancel": "取消",
  "Cannot delete path endpoints": "唔可以刪除路徑端點",
  "Change platforms": "轉月台",
  "Change platforms at {station}": "喺 {station} 轉月台",
  "Check your connection and try again": "檢查網絡連線後再試",
  "Checking edge metadata…": "檢查邊緣中繼資料…",
  "China T-Union Cards": "交通聯合卡",
  "Choose how to open a review PR on": "選擇喺邊度開審查 PR 嘅方式",
  "Choose operator + route →": "選擇營運商 + 路線 →",
  "Choose your default fare ticket type for trip plans.": "選擇規劃行程時用以估算車費的預設車票種類。",
  "Choose your preferred language": "選擇你偏好的語言",
  "Circular": "循環",
  "Citybus": "城巴",
  "Citybus (CTB)": "城巴（CTB）",
  "Clear": "清除",
  "Clear selection": "清除選擇",
  "Clear via": "清除途經",
  "Click anywhere on the map for {field}": "喺地圖上任意位置撳一下，設定{field}",
  "Close": "關閉",
  "Cloud": "雲端",
  "Cloud: live data first, downloaded copy as the offline fallback. Local: serve the downloaded copy directly to save mobile data.": "雲端：優先使用即時資料，已下載副本作為離線後備。本機：直接使用已下載副本以節省流動數據。",
  "Community data feed": "社群數據源",
  "Concessionary fare on domestic routes; excl. AEL, EAL First Class, Lo Wu & Lok Ma Chau": "市區路綫優惠票價；唔包括 AEL、東鐵頭等、羅湖同落馬洲",
  "Confirm": "確認",
  "Confirm (Enter) or Revert (Esc) Follow roads first": "請先確認（Enter）或還原（Esc）沿路行",
  "Confirm or Revert Follow roads first": "請先確認或還原沿路行",
  "Confirm or Revert the current Follow roads result first": "請先確認或還原目前嘅沿路行結果",
  "Confirm or Revert the path first": "請先確認或還原路徑",
  "Contactless Bank Cards": "非接觸式銀行卡",
  "Contribute": "貢獻",
  "Contribute closed — desktop only": "貢獻已關閉 —— 僅限桌面版",
  "Contribute route path": "貢獻路線路徑",
  "Copy JSON": "複製 JSON",
  "Could not copy — use Download instead": "無法複製 —— 請改用下載",
  "Could not get location": "無法取得位置",
  "Could not import JSON": "無法匯入 JSON",
  "Could not load route path": "無法載入路線路徑",
  "Could not reach data edge.": "無法連接到數據邊緣。",
  "Could not reach the submit API.": "無法連接到提交 API。",
  "Could not resolve LRT coords for route {r}": "無法解析路線 {r} 嘅輕鐵座標",
  "Couldn’t load nearby routes": "載入唔到附近路線",
  "Couldn’t load routes": "載入唔到路線",
  "Current location": "現時位置",
  "Data cache": "資料快取",
  "Data cache enabled": "已啟用離線資料快取",
  "Data update available": "有可用數據更新",
  "Data: MTR open data · Protomaps · OpenStreetMap contributors.": "數據：港鐵開放數據 · Protomaps · OpenStreetMap 貢獻者。",
  "Dataset status": "數據集狀態",
  "Default:": "預設：",
  "Delete ({n})": "刪除（{n}）",
  "Delete All Data on This Device": "刪除此裝置上的所有資料",
  "Delete all data": "刪除所有資料",
  "Delete all data?": "刪除所有資料？",
  "Delete selected": "刪除已選",
  "Deleted {n} points": "已刪除 {n} 個點",
  "Deleted {n} points · {m} remain · Undo available": "已刪除 {n} 個點 · 剩餘 {m} 個 · 可復原",
  "Deletes every cached byte, preference and onboarding state, then restarts the app.": "刪除所有已暫存資料、偏好設定及入門狀態，然後重新啟動應用程式。",
  "Densifying segments OSRM can handle…": "加密路段，令 OSRM 可以處理…",
  "Departure": "出發",
  "Departure · Now (UTC+8)": "出發 · 而家（UTC+8）",
  "Departure · {label}": "出發 · {label}",
  "Departure time (Hong Kong, UTC+8)": "出發時間（香港，UTC+8）",
  "Departure · {time}": "出發 · {time}",
  "Desktop only · mouse/trackpad recommended.": "僅限桌面 · 建議使用滑鼠／觸控板。",
  "Destination": "目的地",
  "Developer": "開發者",
  "Direction": "方向",
  "Done": "完成",
  "Download GTFS": "下載 GTFS",
  "Download JSON": "下載 JSON",
  "Download JSON copy": "下載 JSON 副本",
  "Download PMTiles": "下載 PMTiles",
  "Download failed": "下載失敗",
  "Download offline data": "下載離線資料",
  "Download or copy the JSON and share it with moderators if needed.": "如有需要，請下載或複製 JSON 並分享畀版主。",
  "Downloading offline data…": "下載離線資料中…",
  "Downloads": "下載",
  "Drag a box on the map · +drag to add · amber = offset from route · red = selected · remove": "喺地圖上拖曳框選 · +拖曳以新增 · 琥珀色 = 偏離路線 · 紅色 = 已選 · 移除",
  "Draw or load a path first (need ≥ 2 points)": "請先繪製或載入路徑（需要 ≥ 2 個點）",
  "Drawing route…": "繪製路線中…",
  "Drop a .json contribution file": "放入一個 .json 貢獻檔案",
  "E2E testing only — not shipped in the app bundle.": "僅限 E2E 測試——唔會隨應用程式包發佈。",
  "EAL First Class": "東鐵頭等",
  "ETA route browser": "ETA 路線瀏覽器",
  "ETA unavailable · checked {t}": "ETA 不可用 · {t} 檢查",
  "East Rail Line First Class": "東鐵綫頭等",
  "Edit mode": "編輯模式",
  "Edit path turns (hollow green) and/or": "編輯路徑轉彎點（空心綠色）及／或",
  "Enable": "啟用",
  "Enter a Destination/Route": "輸入目的地／路線",
  "Enter a route number (e.g. 38, S1, E11).": "輸入路線編號（例如 38、S1、E11）。",
  "Enter an MTR line code: TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, AEL": "輸入港鐵路綫代碼：TWL、ISL、KTL、TML、EAL、TCL、TKL、SIL、DRL、AEL",
  "Est. arrive": "預計到達",
  "Estimated arrival (Hong Kong time)": "預計到達時間（香港時間）",
  "Expand or collapse": "展開或收合",
  "Expand or collapse panel": "展開或收合面板",
  "Fare": "車費",
  "Fare · {type}": "車費 · {type}",
  "Fare tables unavailable — times still work": "車費表不可用——時間仍然有效",
  "Fares, line / LRT routes and stops, MTR Bus schedules.": "車費、路綫／輕鐵路線同站點、港鐵巴士時間表。",
  "Fastest": "最快",
  "Fetch more live data": "攞更多即時數據",
  "Fetch more live data disabled": "已關閉「獲取更多實時數據」",
  "Fetch more live data enabled": "已開啟「獲取更多實時數據」",
  "Fetch the full dataset for offline use. This will be the main data source if preferred in the “Prefer data source” setting above.": "下載完整數據集以離線使用。如果喺上面「偏好數據來源」設定中揀咗，呢個會係主要數據來源。",
  "Fewer transfers preferred": "偏好較少轉乘",
  "Filter stops:": "篩選站點：",
  "Finishing…": "完成中…",
  "First-party code": "自家代碼",
  "Fixed time": "指定時間",
  "Follow roads": "沿道路",
  "Follow roads calculation": "沿道路計算",
  "Follow roads confirmed": "已確認沿路行",
  "Follow roads confirmed · {n} path pts · Undo still available · Hide overlay when done": "已確認沿路行 · {n} 個路徑點 · 仍可復原 · 完成後隱藏疊加層",
  "Follow roads reverted": "已還原沿路行",
  "Follow roads reverted · {n} path pts restored": "已還原沿路行 · 已恢復 {n} 個路徑點",
  "Recalculate path": "重新計算路徑",
  "Recalc preview: {ins} road pts via {n} section(s) · {before}→{after} pts — Confirm or Revert": "重新計算預覽：經道路重排 {ins} 個點 · {n} 段 · {before}→{after} 個點——請確認或還原",
  "Couldn't reroute along roads — OSRM is unavailable. Path unchanged.": "無法沿道路重新排序——OSRM 不可用。路徑保持不變。",
  "Recalculate needs a connection — you appear to be offline.": "重新計算需要網絡連線——你似乎已離線。",
  "Road assistant: recalculating section {i}/{n}…": "道路助手：正重新計算第 {i}/{n} 段…",
  "Road assistant stopped: OSRM is rate-limiting or down — try again in a minute.": "道路助手已停止：OSRM 正限制請求或離線——請一分鐘後再試。",
  "Follow-roads overlay hidden": "已隱藏沿路行疊加層",
  "Add blocker": "加阻擋點",
  "Blocker added": "已加阻擋點",
  "Blocker added — Follow roads will avoid this junction": "已加阻擋點——沿道路會避開呢個路口",
  "Blocker already there": "呢度已經有阻擋點",
  "Blocker placement off": "已停止放置阻擋點",
  "Blocker removed": "已移除阻擋點",
  "Blockers cleared": "已清除阻擋點",
  "blockers": "阻擋點",
  "Cannot set the first point as last": "唔可以將第一個點設做終點",
  "Clear blockers": "清除阻擋點",
  "Click the map to drop a blocker": "喺地圖撳一下放阻擋點",
  "Focused point {n} · 1 = start here · 2 = last here": "已選第 {n} 點 · 1 = 呢度做起點 · 2 = 呢度做終點",
  "Junction blocker (avoid this road)": "路口阻擋點（避開呢條路）",
  "Line now ends here": "路線而家喺呢度完",
  "Line start moved here": "路線起點已移到呢度",
  "loop": "循環",
  "Mode: Path turns (V) — drag rings · arrows show direction · 1 start · 2 last": "模式：路徑轉彎（V）——拖圓環 · 箭咀顯示方向 · 1 起點 · 2 終點",
  "Mode: Select (B) — box-select · Follow roads snaps selected only": "模式：選取（B）——框選 · 沿道路只吸附已選嘅點",
  "Need a focused path point — click a green ring first": "先撳一個綠色圓環再揀起點／終點",
  "Zoom Chord": "放大貼路",
  "Zoom Chord disabled": "已關閉放大貼路",
  "Zoom Chord enabled": "已開啟放大貼路",
  "On non-contributed bus routes, road-snap the GTFS line onto OpenStreetMap roads when you zoom in. Uses the on-device street graph with OSRM only as backup.": "未有貢獻路徑嘅巴士線，放大地圖時會將 GTFS 線貼上 OpenStreetMap 道路。採用裝置內街道圖計算，OSRM 只作後備。",
  "Path already ends here": "路線已經喺呢度完",
  "Path already starts here": "路線已經喺呢度開始",
  "Path end set · {n} pts remain": "已設終點 · 剩 {n} 個路徑點",
  "Path mode: drag rings · click a ring then 1/2 for start/last · Shift+click blocker · R Follow roads": "路徑模式：拖圓環 · 撳圓環再按 1/2 設起點／終點 · Shift+撳加阻擋點 · R 沿道路",
  "Path rotated · this point is now the start": "已旋轉路徑 · 呢一點而家係起點",
  "Placing blockers — click the wrong road at a junction · Esc to stop": "放置阻擋點——撳路口行錯嗰邊 · Esc 停止",
  "Select mode: Follow roads snaps selected points only. Select some, or leave Select mode to snap all.": "選取模式：沿道路只吸附已選嘅點。請先選點，或者離開選取模式先吸附成條線。",
  "Select mode: box-select · Follow roads snaps selected points only · Del removes": "選取模式：框選 · 沿道路只吸附已選點 · Del 刪除",
  "Select mode (B) — Follow roads snaps selected points only": "選取模式（B）——沿道路只吸附已選嘅點",
  "Select points first, or press V to snap the whole path": "請先選點，或者撳 V 吸附成條路徑",
  "Service disruption": "服務受阻",
  "Set as last": "設做終點",
  "START": "起",
  "END": "終",
  "Start here": "呢度做起點",
  "Cutoff stop (by sequence — not the overlapping pin)": "分界站（按站序——唔好撳疊埋嘅針）",
  "hidden": "已隱藏",
  "Previous stop": "上一站",
  "Next stop": "下一站",
  "Hide before": "隱藏之前",
  "Hide after": "隱藏之後",
  "Show all": "顯示全部",
  "Showing all": "已顯示全部",
  "Showing all stops and path": "已顯示全部站點同路徑",
  "Click a stop pin first, then Hide before / Hide after": "先撳一個站點，再隱藏之前／之後",
  "Nothing before the first stop": "第一個站之前冇嘢好隱藏",
  "Nothing after the last stop": "最後一個站之後冇嘢好隱藏",
  "showing {n}/{m}": "顯示 {n}/{m}",
  "Showing from #{n} {name} · hidden {k} stops before · 0 to show all": "由 #{n} {name} 起顯示 · 已隱藏之前 {k} 個站 · 0 顯示全部",
  "Showing through #{n} {name} · hidden {k} stops after · 0 to show all": "顯示到 #{n} {name} · 已隱藏之後 {k} 個站 · 0 顯示全部",
  "Focused stop #{n} {name} · [ hide before · ] hide after · 0 show all": "已選 #{n} {name} · [ 隱藏之前 · ] 隱藏之後 · 0 顯示全部",
  "Mode: Visual stops (S) — click a stop then [ hide before / ] hide after": "模式：視覺站點（S）——撳一個站再 [ 隱藏之前 / ] 隱藏之後",
  "Visual stops: click a pin then [ / ] to hide the other half of a circular · drag to adjust": "視覺站點：撳圓針再 [ / ] 隱藏循環線另一半 · 拖曳調整",
  "Fonts": "字體",
  "Free MTR link": "港鐵免費通道",
  "Free MTR link: {from} → {to}": "港鐵免費通道：{from} → {to}",
  "From": "出發地",
  "From plan": "從計劃",
  "Full route": "全程",
  "GMB": "小巴",
  "GMB (green minibus)": "小巴（綠色專線小巴）",
  "GMB route code required": "需要小巴路線代碼",
  "GMB route {code} not found. Try the public code (e.g. 1, 44A).": "搵唔到小巴路線 {code}。請試公開代碼（例如 1、44A）。",
  "GTFS feed builder (© 2025 Wheels Transit) behind hk.gtfs.zip and the routing graph; feed data is derived from the government sources above.": "GTFS 數據源建置器（© 2025 Wheels Transit），位於 hk.gtfs.zip 同路線規劃圖背後；數據源內容衍生自上面嘅政府來源。",
  "GTFS → .wheelsrouter graph compiler, run in CI (wheels-router-nano ecosystem; not shipped).": "GTFS → .wheelsrouter 路線圖編譯器，喺 CI 執行（wheels-router-nano 生態；唔會隨應用程式發佈）。",
  "Getting your location…": "正在取得你嘅位置…",
  "GitHub Repository": "GitHub 儲存庫",
  "GitHub account": "GitHub 帳戶",
  "GitHub login failed": "GitHub 登入失敗",
  "GitHub login finished": "GitHub 登入完成",
  "GitHub login required": "需要 GitHub 登入",
  "Gov open data terms": "政府開放數據條款",
  "Green minibus routes, stops and ETAs.": "綠色專線小巴路線、站點同 ETA。",
  "Hide ETA to browse the full stop list": "隱藏 ETA 以瀏覽全部車站",
  "Hide beta banner for this session": "今次使用期間隱藏測試版橫額",
  "Hide beta banner?": "隱藏測試橫額？",
  "Hide calculation overlay": "隱藏計算疊加層",
  "High (more data)": "高（更多資料）",
  "High accuracy": "高準確度",
  "Holiday": "假日",
  "Hong Kong Community GTFS": "香港社群 GTFS",
  "Hong Kong map": "香港地圖",
  "Hong Kong transit map & trip planner. Routes use the public GTFS graph (RAPTOR) with Octopus adult fare estimates. Search supports": "香港交通地圖及行程規劃。路線使用公開 GTFS 路線圖（RAPTOR），附八達通成人車費估算。搜尋支援",
  "I agree to all terms and policies": "我同意所有條款及政策",
  "I agree to the Terms of Service and Privacy Policy": "我同意服務條款及私隱政策",
  "I understand": "我明白",
  "Import JSON": "匯入 JSON",
  "Import a downloaded contribution JSON to continue editing": "匯入已下載嘅貢獻 JSON 以繼續編輯",
  "Import failed": "匯入失敗",
  "Imported JSON · {n} points": "已匯入 JSON · {n} 個點",
  "Imported {id} · {n} path pts · {m} visual stops · continue editing": "已匯入 {id} · {n} 個路徑點 · {m} 個視覺站點 · 繼續編輯",
  "In-station interchange": "站內轉乘",
  "In-station interchange at {place}": "站內轉乘，喺 {place}",
  "Inbound / I / DOWN / seq 2": "回程／I／DOWN／seq 2",
  "Indoor interchange": "室內轉乘",
  "Indoor interchange: {from} → {to}": "室內轉乘：{from} → {to}",
  "Invalid JSON object": "無效嘅 JSON 物件",
  "Invalid place": "無效地點",
  "JSON copied": "已複製 JSON",
  "JSON copied to clipboard": "已複製 JSON 到剪貼簿",
  "JSON downloaded": "已下載 JSON",
  "JSON needs coordinates with at least 2 [lon,lat] points": "JSON 需要至少 2 個 [lon,lat] 座標點",
  "JoyYou $2/20% scheme; full adult for AEL, Lo Wu, Lok Ma Chau & Racecourse": "樂悠咭 $2／20% 優惠；AEL、羅湖、落馬洲同馬場收成人票價",
  "KMB": "九巴",
  "KMB / Citybus": "九巴／城巴",
  "KMB / LWB": "九巴／龍運",
  "KMB/LWB": "九巴／龍運",
  "Keep banner": "保留橫額",
  "LIVE": "實時",
  "LRT": "輕鐵",
  "LRT route CSV empty": "輕鐵路線 CSV 為空",
  "LRT route number required (e.g. 505, 507, 610)": "需要輕鐵路線編號（例如 505、507、610）",
  "LWB": "龍運巴士",
  "Language": "語言",
  "Language · {label}": "語言 · {label}",
  "Last point removed": "已移除最後一個點",
  "Later": "稍後",
  "Least fare": "車費最低",
  "Licenses": "許可證",
  "Light Rail": "輕鐵",
  "Light Rail (LRT)": "輕鐵（LRT）",
  "Live": "即時",
  "Live ETAs · {liveN}/{total} routes · {t} · refreshes every 1 min": "即時 ETA · {liveN}/{total} 條路線 · {t} · 每 1 分鐘更新",
  "Live ETAs failed — will retry": "即時 ETA 失敗——會重試",
  "Live OSRM path · {stops} stops · {n} pts (no matching published path). Press R to follow roads.": "即時 OSRM 路徑 · {stops} 個站點 · {n} 個點（冇匹配嘅已發佈路徑）。撳 R 沿路行。",
  "Live Position Engine": "即時位置引擎",
  "Live Position Engine (Prediction-based)": "即時位置引擎（預測）",
  "Live Position Engine disabled": "已關閉即時位置引擎",
  "Live Position Engine enabled": "已開啟即時位置引擎",
  "Live arrivals": "即時到站",
  "Live bus positions": "即時巴士位置",
  "Live bus positions disabled": "已關閉實時巴士位置",
  "Live bus positions enabled": "已開啟實時巴士位置",
  "Live est. arrive": "即時預計到達",
  "Live {liveN} · Scheduled {schedN} · {total} routes · {t}": "即時 {liveN} · 預定 {schedN} · 共 {total} 條路線 · {t}",
  "Load a calculated path or draw at least 2 points.": "載入計算路徑或繪製至少 2 個點。",
  "Load a path first": "請先載入路徑",
  "Load calculated path": "載入已計算路徑",
  "Load failed": "載入失敗",
  "Load path": "載入路徑",
  "Load path not supported for operator {ag} yet — use From plan or draw": "暫未支援營運商 {ag} 載入路徑 —— 請使用「從計劃」或自行繪製",
  "Loaded calculated path from plan ({n} pts). Follow roads (R) to hug streets, then edit.": "已從計劃載入計算路徑（{n} 個點）。撳 R 沿路行以貼合街道，然後編輯。",
  "Loaded path from current plan": "已載入目前計劃嘅路徑",
  "Loading WASM router…": "載入 WASM 路線規劃器…",
  "Loading nearby routes…": "載入附近路線中…",
  "Loading route…": "載入路線中…",
  "Loading routes…": "載入路線中…",
  "Loading stops + checking published overrides…": "載入站點 + 檢查已發佈覆寫…",
  "Loading {co} {id}…": "載入中：{co} {id}…",
  "Loading {n} pinned route{s}…": "載入中：已釘選 {n} 個站點{s}…",
  "Loading {n} pinned stop{s}…": "載入中：已釘選 {n} 個站點{s}…",
  "Loads this route’s published override if any; otherwise a": "載入此路線已發佈嘅覆寫（如有）；否則載入",
  "Local": "本機",
  "Location permission denied": "位置權限被拒絕",
  "Location request timed out": "位置請求逾時",
  "Location unavailable": "無法取得位置",
  "Log in and open a PR from": "登入並從",
  "Log in with GitHub": "使用 GitHub 登入",
  "Log in with GitHub first (or switch to Bot account)": "請先登入 GitHub（或切換到 Bot 帳戶）",
  "Log in with GitHub to submit with your account, or switch to Bot account.": "登入 GitHub 以用你嘅帳戶提交，或切換到 Bot 帳戶。",
  "Log out": "登出",
  "Logged out of GitHub": "已登出 GitHub",
  "Lower fare preferred": "偏好較低車費",
  "MTR": "港鐵",
  "MTR (heavy rail)": "港鐵（重型鐵路）",
  "MTR Corporation open data": "港鐵公司開放數據",
  "MTR ends": "港鐵結束",
  "MTR open data terms": "港鐵開放數據條款",
  "MTR preferred": "港鐵優先",
  "Main": "主頁",
  "Map": "地圖",
  "Map data and services": "地圖數據同服務",
  "Map error: {msg}": "地圖錯誤：{msg}",
  "Map failed to load tiles": "地圖載入唔到圖磚",
  "Map ready · streaming hongkong.pmtiles": "地圖就緒 · 串流 hongkong.pmtiles",
  "Map rendering engine (MapLibre contributors).": "地圖渲染引擎（MapLibre 貢獻者）。",
  "Map rendering paused — recovering…": "地圖渲染暫停——恢復中…",
  "Map resumed": "地圖已恢復",
  "Map unavailable": "地圖無法使用",
  "Map didn't recover — reloading…": "地圖未恢復——重新載入中…",
  "Metadata unavailable — map may still load from PMTiles URL": "中繼資料不可用——地圖仍可從 PMTiles URL 載入",
  "Minimise journey time": "縮短行程時間",
  "Mode": "模式",
  "Mode · {day}": "模式 · {day}",
  "Mode: Path turns (V) — drag hollow green rings": "模式：路徑轉彎點（V）——拖曳空心綠色圓環",
  "Modes · {methods}": "模式 · {methods}",
  "MTR Bus": "港鐵巴士",
  "Meet at {place}": "喺 {place} 會合",
  "Meet friends here": "喺呢度會合朋友",
  "Meet friends here (optional)": "喺呢度會合朋友（可選）",
  "Nearby": "附近",
  "A new version of MORGAN Travelers is ready. Reload now to get it?": "MORGAN Travelers 有新版本可用。而家重新載入以取得？",
  "Bus · {label}": "巴士 · {label}",
  "Data cache disabled — data source reset to Cloud": "已停用離線資料快取 — 資料來源重設為雲端",
  "Fare · {fare}": "車費 · {fare}",
  "Mode · {mode}": "模式 · {mode}",
  "Modes · {modes}": "交通方式 · {modes}",
  "MORGAN Travelers (main app)": "MORGAN Travelers（主應用程式）",
  "N/A": "不適用",
  "NLB": "新大嶼山巴士",
  "Need at least 2 path points": "至少需要 2 個路徑點",
  "Next": "下一步",
  "No GMB stops for {code} seq {seq}": "搵唔到小巴 {code} 順序 {seq} 嘅站點",
  "No LRT stops for route {r} direction {dir}. Check route no. (e.g. 505).": "搵唔到路線 {r} 方向 {dir} 嘅輕鐵站。請檢查路線編號（例如 505）。",
  "No departure": "冇班次",
  "No departure data": "冇班次資料",
  "No draft to copy": "沒有可複製嘅草稿",
  "No draft to download": "沒有可下載嘅草稿",
  "No large offsets found": "冇發現大型偏移",
  "No nearby routes": "附近冇路線",
  "No offset points over {m}m — path is clean enough": "冇超過 {m} 米嘅偏移點 —— 路徑夠乾淨",
  "No override for this route — using similar published path from {from} (shared corridor) · {n} pts. Edit & submit your own.": "呢條路線冇覆寫 —— 使用來自 {from} 嘅類似已發佈路徑（共用走廊）· {n} 個點。編輯並提交你嘅版本。",
  "No places found": "搵唔到地點",
  "No places found — try “Yuen Long Station”, @MTR, or tap the map": "搵唔到地點 —— 試下「Yuen Long Station」、@MTR，或撳地圖",
  "No places match “{q}”": "冇地方符合「{q}」",
  "No plan selected — search a route instead": "未選擇計劃 —— 請改為搜尋路線",
  "No points in box (endpoints are protected)": "框入面冇點（端點受保護）",
  "No points selected": "未選擇任何點",
  "No routes found": "搵唔到路線",
  "No routes found — try other points": "搵唔到路線 — 試下其他地點",
  "No routes found through via — try another meeting point": "搵唔到經呢個途經點嘅路線 — 試下另一個會合地點",
  "No routes found.": "搵唔到路線。",
  "No routes match “{q}”": "冇路線符合「{q}」",
  "No routes or places for “{q}”": "搵唔到「{q}」嘅路線或地點",
  "No station coords found for MTR {line}": "搵唔到 MTR {line} 嘅車站座標",
  "No stop list for {co} {id}.": "冇 {co} {id} 嘅站點列表。",
  "No stops found for {ag} {r} ({dir})": "搵唔到 {ag} {r}（{dir}）嘅站點",
  "No transit legs for ETA": "冇交通路段可供 ETA",
  "No usable stops after merge for {ag} {r}": "合併後搵唔到 {ag} {r} 嘅可用站點",
  "No valid coordinates in JSON": "JSON 入面冇有效座標",
  "No {mode} stops matched — try another name": "冇匹配嘅 {mode} 站點 —— 試下另一個名稱",
  "No, use cloud only": "否，僅使用雲端",
  "Not now": "暫時唔要",
  "Notes for moderators": "版主備註",
  "Nothing in box": "框入面冇嘢",
  "Nothing to confirm": "冇嘢可以確認",
  "Nothing to redo": "冇嘢可以重做",
  "Nothing to revert": "冇嘢可以還原",
  "Nothing to undo": "冇嘢可以復原",
  "Now": "而家",
  "Octopus Adult/Elderly": "八達通成人／長者",
  "Octopus Child": "八達通小童",
  "Octopus JoyYou Cards (60–64)": "樂悠咭（60–64 歲）",
  "Octopus JoyYou Cards (65+)": "樂悠咭（65 歲以上）",
  "Octopus Student": "八達通學生",
  "Off": "關",
  "Offline Data": "離線資料",
  "Offline data": "離線資料",
  "Offline — using downloaded data": "離線——使用已下載資料",
  "Offline data ready": "離線資料已就緒",
  "On": "開",
  "Onboarding": "入門導覽",
  "Open source & data licenses": "開源及數據許可證",
  "Operator / mode": "營運商／模式",
  "Operator and route required": "需要營運商同路線",
  "Opposite": "相反方向",
  "Optional experimental features. You can change these anytime in Settings.": "可選的實驗性功能。你隨時可以在設定中更改。",
  "Origin": "起點",
  "Origin set to current location": "出發地已設為目前位置",
  "Origin suggestions": "出發地建議",
  "Original path (before)": "原始路徑（之前）",
  "Other / joint": "其他／聯營",
  "Outbound / O / UP / seq 1": "去程／O／UP／seq 1",
  "Outside service": "服務時間外",
  "Outside service hours": "服務時間外",
  "Override path loaded{id} · {n} pts": "已載入覆寫路徑{id} · {n} 個點",
  "Path cleared": "已清除路徑",
  "Path contributions are desktop-only (wide screen + mouse/trackpad).": "路徑貢獻只限桌面版（寬螢幕 + 滑鼠／觸控板）。",
  "Path loaded · {stops} stops · {n} pts (live densify)": "已載入路徑 · {stops} 個站點 · {n} 個點（即時加密）",
  "Path mode: drag hollow green handles · click path to insert · Alt+click delete · B for select": "路徑模式：拖動空心綠色手柄 · 撳路徑以插入 · Alt+撳刪除 · B 選擇",
  "Path redone": "已重做路徑",
  "Path turning points (V)": "路徑轉彎點（V）",
  "Path turns": "路徑轉彎",
  "Path turns mode (V)": "路徑轉向模式（V）",
  "Path unchanged — debug overlay shows why": "路徑冇變 —— 除錯疊加層會顯示原因",
  "Path undone": "已復原路徑",
  "Pick a via place from the list, or clear Via": "喺清單揀一個途經地點，或清除途經",
  "Planning via {place}…": "正在規劃經 {place}…",
  "Planning…": "規劃緊…",
  "Pin": "釘選",
  "Pin plan": "釘選路線",
  "Pin route": "釘選路線",
  "Pin stop": "釘選站點",
  "Pin this route to the toolbar": "將此路線釘選到工具列",
  "Pin this stop": "釘選此站點",
  "Pin this trip": "釘選此行程",
  "Pinned": "已釘選",
  "Pinned Routes": "已釘選站點",
  "Pinned Stops": "已釘選站點",
  "Pinned routes": "已釘選站點",
  "Pinned stops": "已釘選站點",
  "Pinned Trips": "已釘選行程",
  "Nothing pinned yet": "未有釘選項目",
  "Pin trip plans from Plan Results, or open a route, pick a stop, then tap Pin.": "喺規劃結果釘選行程，或開啟路線揀站再撳釘選。",
  "Pin a route stop or trip plan": "釘選站點或行程規劃",
  "No pinned items": "未有釘選項目",
  "Show detail": "顯示詳情",
  "Open pinned {id}": "開啟已釘選 {id}",
  "Open {n} pinned stops": "開啟 {n} 個已釘選站點",
  "Open {n} pinned trips": "開啟 {n} 個已釘選行程",
  "Open {n} pinned items": "開啟 {n} 個已釘選項目",
  "Place": "地點",
  "Place search / reverse geocoding (service).": "地點搜尋／反向地理編碼（服務）。",
  "Place search returned invalid JSON — is /geocode proxy running?": "地點搜尋回傳咗無效 JSON —— /geocode proxy 有冇執行緊？",
  "Places": "地點",
  "Places · tap to plan trip": "地點 · 點按規劃行程",
  "Plan Results": "路線建議",
  "Plan failed: {msg}": "規劃失敗：{msg}",
  "Plan trip": "規劃行程",
  "Platform {p}": "{p} 號月台",
  "Please get on the {noun} at {place}": "請喺 {place} 上{noun}",
  "Please get on the {noun} at {station}": "請喺 {station} 上{noun}",
  "Please review and accept all terms and policies to continue.": "請細閱並接受所有條款及政策後繼續。",
  "Please review and accept our Terms of Service and Privacy Policy to continue.": "請細閱並接受我們的服務條款及私隱政策，方可繼續。",
  "Predicted bus positions (busPositionEngine, trafficSpeed, busSchedules). Source under GNU GPLv3 only; see licenses/GPL-3.0.txt.": "預測巴士位置（busPositionEngine、trafficSpeed、busSchedules）。原始碼僅以 GNU GPLv3 授權；見 licenses/GPL-3.0.txt。",
  "Predicted Live Positions are for reference only.": "預測嘅即時巴士位置僅供參考。",
  "Prediction accuracy": "預測準確度",
  "Prefer": "偏好",
  "Prefer data source": "偏好數據來源",
  "Prefer {label}": "偏好：{label}",
  "Prefer {prefer} data": "偏好 {prefer} 資料",
  "Prefer {prefs}": "偏好 {prefs}",
  "Preparing manifest…": "準備清單中…",
  "Preparing offline data…": "準備離線資料中…",
  "Preview only —": "僅預覽——",
  "Preview: {snap} snapped · {raw} raw · {dens} densified · {fail} kept · {before}→{after} pts — Confirm or Revert": "預覽：{snap} 個已吸附 · {raw} 個原始 · {dens} 個加密 · {fail} 個保留 · {before}→{after} 點 —— 確認或還原",
  "Privacy Policy": "私隱政策",
  "Profile": "個人資料",
  "Profile menu": "個人資料選單",
  "Published override loaded{id} · {n} path pts · {stops} stops. Edit & re-submit to improve, or Follow roads (R).": "已載入已發佈覆寫{id} · {n} 個路徑點 · {stops} 個站點。編輯並重新提交以改善，或沿路行（R）。",
  "QR Code Adult/Elderly": "二維碼成人／長者",
  "QR Code Child": "二維碼小童",
  "RBS": "居民巴士",
  "Re-run onboarding": "重新執行入門導覽",
  "Recommended": "推薦",
  "Redo": "重做",
  "Redo (⌘/Ctrl+Shift+Z or ⌘/Ctrl+Y)": "重做（⌘/Ctrl+Shift+Z 或 ⌘/Ctrl+Y）",
  "Redo · {n} path pts · {u} undo · {r} redo": "重做 · {n} 個路徑點 · 可復原 {u} 次 · 可重做 {r} 次",
  "Reload": "重新載入",
  "Reload now to fully apply the new language?": "重新載入即可完整套用新語言。立即重新載入？",
  "Reload once so the service worker is active": "重新載入一次以啟用 service worker",
  "Reload to apply language?": "重新載入以套用語言？",
  "Required for “GitHub account” submit.": "使用「GitHub account」提交時需要。",
  "Reset departure time to now": "將出發時間重設為而家",
  "Reset to now (UTC+8)": "重設為而家（UTC+8）",
  "Residents' Bus Services (RBS, e.g. Ma Wan NR330/NR332 and Discovery Bay DB routes) charge a lower fare when paying with a registered Octopus card. Off = visitor fare.": "居民巴士服務（RBS，例如馬灣 NR330/NR332 同愉景灣 DB 路線）使用已登記八達通卡付款時收費較低。關 = 訪客車費。",
  "Restart now": "即刻重新載入",
  "Restart to load the latest data from the cloud.": "重新載入以載入雲端最新數據。",
  "Resume a downloaded draft (or drop a": "恢復已下載嘅草稿（或將",
  "Restored your in-progress edit": "已還原你未完成嘅編輯",
  "Retry": "重試",
  "Revert": "還原",
  "Review the map · Confirm to keep · Revert to undo": "檢查地圖 · 確認以保留 · 還原以取消",
  "Ride {n} stop{s}": "搭 {n} 個站",
  "Road assistant failed": "道路助手失敗",
  "Road assistant: nothing changed — see map legend (grey=original, amber=kept raw).": "道路助手：冇任何改變 —— 請參考地圖圖例（灰色=原本，琥珀色=保留原始）。",
  "Road assistant: snapping vertices onto streets (keeps all your points)…": "道路助手：正將頂點吸附到街道（保留你所有點）…",
  "Road assistant: {msg}": "道路助手：{msg}",
  "Road-network geometry for bus-route snapping (service; data © OSM contributors).": "巴士路線貼路用嘅道路網絡幾何（服務；數據 © OSM 貢獻者）。",
  "Route / fare dataset used for GMB and ferry fare fallbacks; used per its citation notice (HK Bus Crawling @2021).": "用於小巴同渡輪車費後備嘅路線／車費數據集；按其引用聲明使用（HK Bus Crawling @2021）。",
  "Route / line": "路線／路綫",
  "Route detail": "路線詳情",
  "Route detail actions": "路線詳情操作",
  "Route preferences": "路線偏好",
  "Router failed: {msg}": "路線引擎失敗：{msg}",
  "Router graph failed to load": "路線規劃圖載入失敗",
  "Routes": "路線",
  "Runtime open source": "執行期開源",
  "Same rates as Octopus Adult": "與八達通成人相同收費",
  "Same rates as Octopus Adult/Elderly": "與八達通成人／長者相同收費",
  "Same rates as Octopus Child": "與八達通小童相同收費",
  "Sched": "預定",
  "SCHEDULED": "預定",
  "Saved locally to the overrides pending folder. Open the review page or merge via npm run overrides:merge.": "已儲存到本機 overrides pending 資料夾。開啟審查頁面，或執行 npm run overrides:merge 合併。",
  "Scheduled departures": "定點開出",
  "Search": "搜尋",
  "Search destination or route": "搜尋目的地或路線",
  "Search failed": "搜尋失敗",
  "Search unavailable — run npm run dev (needs /geocode proxy), or tap the map": "搜尋不可用 —— 執行 npm run dev（需要 /geocode proxy），或撳地圖",
  "Searching…": "搜尋中…",
  "Segment densified + inserted mids": "路段加密並插入中點",
  "Segment left as-is": "路段保持原樣",
  "Segment {n}/{total}": "路段 {n}/{total}",
  "Select": "選擇",
  "Select a route first": "請先選擇路線",
  "Select an operator / mode (KMB, GMB, MTR, AEL, LRT, …).": "選擇營運商／模式（KMB、GMB、MTR、AEL、LRT、…）。",
  "Select at least one bus company": "請至少選擇一間巴士公司",
  "Select at least one preference": "請至少選擇一個偏好",
  "Select at least one traffic method": "請至少選擇一種交通工具",
  "Select mode (B)": "選擇模式（B）",
  "Select mode (B) — box-select offset points": "選擇模式（B）—— 框選偏移點",
  "Select mode (B) — box-select · O for offsets": "選擇模式（B）—— 框選 · O 揀偏移",
  "Select mode: drag a box on the map · amber = offset >{n}m · Delete/Backspace removes selected": "選擇模式：喺地圖上拖出一個框 · 琥珀色 = 偏移 >{n} 米 · Delete/Backspace 移除所選",
  "Select offsets": "選擇偏移",
  "Select operator and enter route number first": "請先選擇營運商並輸入路線編號",
  "Selected {n} offset points (>{m}m from route backbone). Delete to clean, or box-select more.": "已選擇 {n} 個偏移點（距離路線主線 >{m} 米）。刪除以清理，或再框選更多。",
  "Selection cleared": "已清除選擇",
  "Select…": "選擇…",
  "Service day mode": "服務日模式",
  "Settings": "設定",
  "Show ETA at this stop": "顯示此站 ETA",
  "Show live bus markers predicted from nearby ETA countdowns.": "以鄰近車站的到站時間推算並顯示巴士即時位置標記。",
  "Show live markers predicted from nearby ETA countdowns.": "以鄰近車站的到站時間推算並顯示即時位置標記。",
  "Show live markers on bus route maps — estimates stitched from the ETA countdowns of nearby stops, not official GPS.": "喺巴士路線地圖顯示即時標記——估算由附近站點嘅 ETA 倒數拼合而成，並非官方 GPS。",
  "Show live markers on route maps — estimates stitched from the ETA countdowns of nearby stops, not official GPS.": "喺路線地圖顯示即時標記——估算由附近站點嘅 ETA 倒數拼合而成，並非官方 GPS。",
  "Show route details": "顯示路線詳情",
  "Show the “Beta Feature” disclaimer while live bus positions are active. Swipe the banner up to hide it for the session.": "啟用即時巴士位置時顯示「測試版功能」聲明。向上掃走橫額以喺今次使用期間隱藏。",
  "Show the “Beta Feature” disclaimer while the Live Position Engine is active. Swipe the banner up to hide it for the session.": "啟用即時位置引擎時顯示「測試版功能」聲明。向上掃走橫額以喺今次使用期間隱藏。",
  "Showing @{mode} stops": "顯示 @{mode} 站點",
  "Signed in as @{login}": "已以 @{login} 登入",
  "Similar override ({from}) · {n} pts": "類似覆寫（{from}）· {n} 個點",
  "Simplest": "最簡單",
  "Single Ride Ticket/Cash": "單程車票／現金",
  "Skip": "略過",
  "Skipped a via that is too close to another point": "已略過同一個點太近嘅途經",
  "Snap link (old → new)": "貼路連結（舊 → 新）",
  "Snap visuals": "貼路視覺",
  "Snap your path onto nearby road edges only — does not re-route (R)": "只會將路徑貼到附近道路邊緣——唔會重新規劃路線（R）",
  "Snapping vertices to nearest road…": "將頂點吸附到最近嘅道路…",
  "Snaps your vertices onto nearby streets. Never deletes points — only adds road detail where OSRM can; weak sections stay as you drew them. Result is drawn on the map as a calculation overlay.": "將你嘅頂點貼到附近街道。絕不刪除點——只會喺 OSRM 可行嘅地方加入道路細節；弱路段保持你原本繪製嘅樣。結果會以計算疊加層畫喺地圖上。",
  "Standard": "標準",
  "Start Using App": "開始使用應用程式",
  "Starting download: {filename}": "開始下載：{filename}",
  "Station names show in Chinese for 廣東話, 繁體中文 and 简体中文; English for others.": "站名：廣東話、繁體中文同简体中文顯示中文站名；其他語言顯示英文。",
  "Step {n} of {m}": "第 {n} 步，共 {m} 步",
  "Stop": "車站",
  "Stop {n}": "站點 {n}",
  "Stops on route": "路線車站",
  "Sub-page actions": "子頁面操作",
  "Submit failed": "提交失敗",
  "Submit for review": "提交審查",
  "Submit for review — mods publish after check.": "提交審查——版主檢查後先會發佈。",
  "Submit method": "提交方式",
  "Submit successful": "提交成功",
  "Submitting…": "提交中…",
  "Swap origin and destination": "交換出發地同目的地",
  "Switch branch": "切換分支",
  "Switch operator": "切換營辦商",
  "Switch branch: {cur} ⇄ {other}": "切換分支：{cur} ⇄ {other}",
  "Switch Departure": "切換開出",
  "Switch direction": "切換方向",
  "Search route": "搜尋路線",
  "Search a route first": "請先搜尋路線",
  "Search and pick a route first": "請先搜尋並揀一條路線",
  "Loading directions…": "載入方向中…",
  "{n} directions on this route": "呢條線有 {n} 個方向",
  "Search a route → pick a real direction": "搜尋路線 → 揀實際方向",
  "Tap the map to set": "撳地圖嚟設定",
  "Tap the map to set destination": "撳地圖設定目的地",
  "Tap the map to set origin": "撳地圖設定出發地",
  "Tap the map to set via": "撳地圖設定途經點",
  "Terms": "條款",
  "Terms & Privacy": "條款及私隱",
  "Terms of Service": "服務條款",
  "The map's graphics engine keeps failing. Reload the page to try again.": "地圖圖形引擎持續故障。重新載入頁面再試。",
  "The terms and policies you agreed to when you first set up Travelers.": "呢啲係你第一次設定 Travelers 時同意嘅條款同政策。",
  "The transit data has been refreshed on the server. Re-download the offline set to get the latest routes, stops and fares?": "伺服器上嘅交通數據已更新。重新下載離線數據集以取得最新路線、站點同車費？",
  "Third-party software, fonts, and data used by Travelers, with license identifiers and attribution links for compliance.": "Travelers 使用嘅第三方軟件、字體同數據，附許可證識別符同出處連結以符合規定。",
  "Third-party software, fonts, and data used by Travelers, with license identifiers and attribution links for compliance. Last updated 12 Aug 2026 — versions are package ranges; lockfile pins apply at build time. SPDX identifiers as declared upstream; full license text is in each project’s distribution.": "Travelers 使用嘅第三方軟件、字體同數據，附許可證識別符同出處連結以符合規定。最後更新 2026 年 8 月 12 日——版本為套件範圍；建置時以 lockfile 鎖定。SPDX 識別符按上游聲明；完整許可證文字喺各項目嘅發佈中。",
  "This browser can't render the map — it needs WebGL2 graphics. Update Chrome or Android System WebView and reload.": "此瀏覽器無法渲染地圖——需要 WebGL2 圖形。更新 Chrome 或 Android System WebView 然後重新載入。",
  "This will delete all cached data, preferences, and onboarded state. Are you sure?": "這將刪除所有已暫存資料、偏好設定及入門狀態。你確定嗎？",
  "Ticket / fare type": "票種／車費類型",
  "Ticket type": "票種",
  "Ticket type used for trip plans and bus boarding prices on route details.": "用於行程規劃同路線詳情中巴士上車價格嘅票種。",
  "Tickets": "車票",
  "Tile archive format and client loader (Protomaps).": "瓦片封存格式同用戶端載入器（Protomaps）。",
  "Timetable · {schedN}/{total} routes · {t}": "時間表 · {schedN}/{total} 條路線 · {t}",
  "To": "目的地",
  "To {dest}": "往 {dest}",
  "Traffic method": "交通工具",
  "Traffic methods": "交通工具",
  "Traffic methods. None selected shows all.": "交通工具。未選擇時顯示全部。",
  "Transfer walk": "轉乘步行",
  "Transit": "交通",
  "Transit data (Hong Kong)": "交通數據（香港）",
  "Transport Department open data": "運輸署開放數據",
  "Travelers panel": "Travelers 面板",
  "Treated as adult Octopus rates": "按成人八達通收費",
  "Trip Plan": "行程規劃",
  "Trip Plan · to {name}": "行程規劃 · 前往 {name}",
  "Trip detail": "行程詳情",
  "Trip plan pinned": "行程計劃已釘選",
  "Trip plan unpinned": "行程計劃已取消釘選",
  "Trip-planning engine (RAPTOR); compiled WASM vendored in this repo (Wheels Labs / Wheels Softworks).": "行程規劃引擎（RAPTOR）；已編譯 WASM 收錄喺此儲存庫（Wheels Labs / Wheels Softworks）。",
  "Try another filter or search term": "試下另一個篩選或搜尋字詞",
  "Try different locations or a later departure.": "試下其他地點，或者遲啲先出發。",
  "Turning off the banner means you understand and agree that predicted live bus positions are inaccurate and for reference only.": "關閉橫額即表示你明白並同意：預測嘅實時巴士位置未必準確，僅供參考。",
  "UI icons, loaded from Google Fonts (Google LLC).": "介面圖示，載入自 Google Fonts（Google LLC）。",
  "UI typeface, loaded from Google Fonts (The Montserrat Project Authors).": "介面字體，載入自 Google Fonts（The Montserrat Project Authors）。",
  "UNLOOP MORGAN Universal Terms of Use for Open-Source Software": "UNLOOP MORGAN 開源軟件通用使用條款",
  "Undo": "復原",
  "Undo (⌘/Ctrl+Z)": "復原（⌘/Ctrl+Z）",
  "Undo · {n} path pts · {u} undo · {r} redo": "復原 · {n} 個路徑點 · 可復原 {u} 次 · 可重做 {r} 次",
  "Unknown MTR line “{line}”. Try TWL, ISL, KTL, TML, EAL, TCL, TKL, SIL, DRL, or AEL.": "未知嘅港鐵路綫「{line}」。請試 TWL、ISL、KTL、TML、EAL、TCL、TKL、SIL、DRL 或 AEL。",
  "Unpin": "取消釘選",
  "Unpin plan": "取消釘選路線",
  "Unpin stop": "取消釘選站",
  "Unpin this trip": "取消釘選此行程",
  "Unpinned {id}": "已取消釘選 {id}",
  "Update available": "有可用更新",
  "Update data": "更新數據",
  "Update frequency": "更新頻率",
  "Update now": "立即更新",
  "Updated —": "已更新——",
  "Updated {n}h ago": "{n} 小時前更新",
  "Updated {n}m ago": "{n} 分鐘前更新",
  "Updated {n}s ago": "{n} 秒前更新",
  "Uploading path for review": "上載路徑以供審查",
  "Use current location": "使用目前位置",
  "Use current location as origin": "使用目前位置作為出發地",
  "Use Resident Fare on RBS": "喺 RBS 使用居民車費",
  "Usual": "平日",
  "Usual uses weekday timetables; Holiday uses Sunday / public-holiday service.": "平日使用週一至五時間表；假日使用星期日／公眾假期服務。",
  "V path · S visual stops · R follow roads · Tab switch. Official greys stay fixed.": "V 路徑 · S 視覺站點 · R 沿路行 · Tab 切換。官方灰色點保持固定。",
  "Vector basemap": "向量底圖",
  "Vertex kept raw (OSRM weak)": "頂點保持原始（OSRM 弱）",
  "Vertex snapped to road": "頂點已貼到道路",
  "Visit your PR": "前往你嘅 PR",
  "Visit {visitN} of {visitTotal} on this route": "此路線第 {visitN}／{visitTotal} 次到訪",
  "Visual stop pins (S) — official stays fixed": "視覺站點標記（S）——官方站點保持固定",
  "Visual stops": "視覺站點",
  "Visual stops mode (S)": "視覺站點模式（S）",
  "Visual stops mode (S) — drag orange pins": "視覺站點模式（S）—— 拖動橙色標記",
  "Visual stops re-projected onto path · official coords still fixed": "視覺站點已重新投影到路徑 · 官方座標仍然固定",
  "Visual stops snapped to path (official unchanged)": "視覺站點已吸附到路徑（官方位置不變）",
  "Visual stops: no stops loaded — Load calculated path first": "視覺站點：未載入任何站點 —— 請先載入計算路徑",
  "Visual stops: {n} orange pins · grey ghost only if moved from official · drag to adjust": "視覺站點：{n} 個橙色標記 · 僅喺移離官方位置時顯示灰色殘影 · 拖動以調整",
  "Via": "途經",
  "Via {n}": "途經 {n}",
  "Via cleared": "已清除途經",
  "Via is the same as the destination": "途經點同目的地一樣",
  "Via is the same as the origin": "途經點同出發地一樣",
  "Via suggestions": "途經建議",
  "Walk": "步行",
  "Walk to {dest}": "步行至 {dest}",
  "Walk to {to}": "步行至 {to}",
  "Walk to destination": "步行至目的地",
  "Walk to station": "步行至車站",
  "Walk the free link to {place}": "步行免費通道至 {place}",
  "Welcome to MORGAN Travelers": "歡迎使用 MORGAN Travelers",
  "Welcome!": "歡迎！",
  "Yes, cache all data": "是，暫存所有資料",
  "You were running on downloaded data. Restart to load the latest data from the cloud.": "你之前用緊離線數據。重新載入即可載入雲端最新數據。",
  "Your name (optional)": "你嘅姓名（可選）",
  "You can add up to {n} vias": "最多可以加 {n} 個途經點",
  "Your path was saved to the review queue.": "你嘅路徑已儲存到審查佇列。",
  "Your path was submitted and a pull request was opened from your GitHub account.": "你嘅路徑已提交，並已由你嘅 GitHub 帳戶開咗 pull request。",
  "Your path was submitted and a review pull request was opened by the site bot.": "你嘅路徑已提交，審查 pull request 已由網站 bot 開咗。",
  "Your path was submitted for review.": "你嘅路徑已提交供審查。",
  "another route": "另一條路線",
  "as {author}": "以 {author} 名義",
  "auto after load": "載入後自動",
  "cycle": "切換",
  "default": "預設",
  "desktop": "桌面",
  "e.g. Central Station · @MTR @LRT @Bus": "例如：中環站 · @港鐵 @輕鐵 @巴士",
  "e.g. Yuen Long Station": "例如：元朗站",
  "e.g. Times Square · meet here": "例如：時代廣場 · 喺呢度會合",
  "e.g. via Mei Tung Street, not terminus bay": "例如：經美東街，唔係巴士總站",
  "filters.": "篩選器。",
  "fork (credited to you).": "分叉開 PR（歸功於你）。",
  "id {id}": "id {id}",
  "min": "分鐘",
  "multi-select": "多選",
  "on this panel).": "拖到此面板）。",
  "path ·": "路徑 ·",
  "published path that covers the same corridor; otherwise live OSRM.": "覆蓋同一走廊嘅已發佈路徑；否則使用即時 OSRM。",
  "roads ·": "道路 ·",
  "route {r}": "路線 {r}",
  "select ·": "選擇 ·",
  "similar": "類似",
  "stops ·": "站點 ·",
  "to discard.": "以丟棄。",
  "to keep,": "以保留，",
  "visual stop pins": "視覺站點標記",
  "{base} - Platform {p}": "{base} - {p}號月台",
  "{h} h": "{h} 小時",
  "{h} h {m} min": "{h} 小時 {m} 分鐘",
  "{kindLabel} {routeId} → {dest}": "{kindLabel} {routeId} 往 {dest}",
  "{n} min": "{n} 分鐘",
  "1 min": "1 分鐘",
  "your": "你嘅",
  "{n} offset points selected": "已選擇 {n} 個偏移點",
  "{n} path points on map (stop names unavailable).": "地圖上有 {n} 個路徑點（暫無車站名稱）。",
  "{n} pinned route{s}": "已釘選 {n} 個站點{s}",
  "{n} pinned stop{s}": "已釘選 {n} 個站點{s}",
  "{n} plan(s) · {ms} ms": "{n} 個方案 · {ms} 毫秒",
  "{n} plan(s) via {place} · {ms} ms": "{n} 個方案經 {place} · {ms} 毫秒",
  "{n} points selected": "已選擇 {n} 個點",
  "{n} points selected · Delete/Backspace to remove · Shift+drag to add": "已選擇 {n} 個點 · Delete/Backspace 移除 · Shift+拖動新增",
  "{n} stops": "{n} 個站",
  "{n}m": "{n} 分",
  "{pts} pts": "{pts} 個點",
  "· green rings = path · orange = visual stop · grey = official fixed": "· 綠色圓環 = 路徑 · 橙色 = 視覺站點 · 灰色 = 官方固定",
};